import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import KnowledgeService from '../../../services/KnowledgeService'
import './styles.scss'
import ModalCreate from './ModalCreate'
import { HelperService } from '../../../services/helper.service'
import { KNOWLEDGE_ALL } from '../../../config'
import Loading from '../../../components/UI/Loading/Loading'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { Button, Stack } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

const helperService = new HelperService()

interface LearningOutcome {
  _id: string
  text: string
}

const UpdateLearningOutcome = () => {
  const { t } = useTranslation('translation')
  const history: any = useHistory()
  const [outcomes, setOutcomes] = useState([])
  const [groupOutcomes, setGroupOutcomes] = useState<LearningOutcome[]>([])

  const [groupId, setGroupId] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const [isShowAdd, setIsShowAdd] = useState(false)
  const knowledgeService = new KnowledgeService()

  const saveOutcomes = async () => {
    if (outcomes.length === 0) return

    setIsLoading(true)
    const learningOutcomes: any = outcomes.map(o => ({
      text: o?.text,
    }))
    try {
      await knowledgeService.saveLearningOutcomesByGroup(
        groupId,
        learningOutcomes,
      )
      helperService.showToaster(t('Success'), 'success')
      history.replace(`${KNOWLEDGE_ALL}?activeTab=viewLearningOutcomes`)
    } catch (error) {
      helperService.showToaster('Error when save learning outcomes')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const getGroupLearnings = async (groupId: string) => {
      const outcomeRes: any =
        await knowledgeService.getLearningOutcomesByGroup(groupId)
      setGroupOutcomes(outcomeRes?.data?.data?.learning_outcomes)
    }

    const getRecommendLearningOutcomes = async (groupId: any) => {
      const outcomeRes: any =
        await knowledgeService.getSuggestLearningOutcomes(groupId)
      setOutcomes(outcomeRes?.data?.data?.learning_outcomes)
    }

    const getData = async (groupId: string) => {
      setIsLoading(true)
      await getGroupLearnings(groupId)
      await getRecommendLearningOutcomes(groupId)
      setIsLoading(false)
    }

    const query = new URLSearchParams(history.location.search)
    const groupId = query.get('group')
    setGroupId(groupId)
    if (groupId) {
      getData(groupId)
    } else {
      history.push(`${KNOWLEDGE_ALL}?activeTab=viewLearningOutcomes`)
    }
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <section className="tw-px-6 tw-py-4">
      <ChildPageHeader
        title={t('Update Learning Outcomes')}
        redirectUrl={`${KNOWLEDGE_ALL}?activeTab=viewLearningOutcomes`}
        slot={{
          action: (
            <Button
              variant="contained"
              onClick={() => {
                saveOutcomes()
              }}
            >
              {t('Save')}
            </Button>
          ),
        }}
      />
      <Stack direction="row" gap={2}>
        <div className="tw-w-1/2">
          <div className="outcomes-wrapper justify-content-center h-100">
            <h2>{t('Previous Learning Outcomes')}</h2>
            <div className="tw-mt-4">
              {groupOutcomes.map(o => (
                <div
                  key={o._id}
                  className="p-3 mb-1 d-flex justify-content-between align-items-center  outcome-item"
                >
                  <div>{o.text}</div>
                  <div
                    className="px-3 clr-blue"
                    role="button"
                    onClick={() => {
                      setOutcomes((prev: any) => [...prev, { text: o.text }])
                    }}
                  >
                    +
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="tw-w-1/2">
          <div className="outcomes-wrapper recommened">
            <h2>{t('Suggested Learning Outcomes')}</h2>
            <div className="tw-mt-4">
              {outcomes.map((o, i) => (
                <div
                  key={i}
                  className="p-3 mb-1 d-flex justify-content-between align-items-center  outcome-item"
                >
                  <div>{o.text}</div>
                  <div
                    className="px-3  clr-grey-text"
                    role="button"
                    onClick={() => {
                      const copy = [...outcomes]
                      copy.splice(i, 1)
                      setOutcomes(copy)
                    }}
                  >
                    x
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Stack alignItems="center" mt={2}>
            <Button
              variant="outlined"
              onClick={() => setIsShowAdd(true)}
              startIcon={<AddIcon fontSize="small" />}
            >
              {t('Add')}
            </Button>
          </Stack>
        </div>
      </Stack>
      <ModalCreate
        show={isShowAdd}
        onHide={() => setIsShowAdd(false)}
        addOutcome={(name: any) => {
          setIsShowAdd(false)
          setOutcomes((prev: any) => [...prev, { text: name }])
        }}
      />
    </section>
  )
}

export default UpdateLearningOutcome
